import { AppLoader } from '@nexans/react-ui-kit'

function ScreenLoader() {
  return (
    <div
      style={{
        position: 'absolute',
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <AppLoader />
    </div>
  )
}

export default ScreenLoader
